import styled from 'styled-components';

export const Label = styled.p<{
  $right?: boolean;
}>`
  margin-right: 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors['neutral-80']};
  display: inline;
  text-align: ${({ $right = false }) => ($right ? 'right' : 'left')};
`;

export const DatePickerArea = styled.div<{
  $disabled: boolean;
  $labelAboveField: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: ${({ $labelAboveField }) => ($labelAboveField ? 'column' : 'row')};
  align-items: ${({ $labelAboveField }) => ($labelAboveField ? 'normal' : 'center')};

  & > * {
    flex: 1 1 0%;
  }

  ${({ $disabled }) =>
    $disabled &&
    `
    opacity: .5;
    pointer-events: none;
  `}

  & > svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors['neutral-100']};
    position: absolute;
    right: 12px;
    bottom: 9.5px;
    pointer-events: none;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-popper {
    z-index: 10;
  }

  & > .react-datepicker__tab-loop {
    flex-grow: 0 !important;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    &::before {
      border-bottom-color: ${({ theme }) => theme.colors['neutral-40']};
    }

    &::after {
      border-bottom-color: ${({ theme }) => theme.colors['neutral-0']};
    }
  }

  .react-datepicker-wrapper {
    display: block;
  }

  .react-datepicker__input-container {
    input {
      border-radius: 4px;
      border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
      background-color: ${({ theme }) => theme.colors['neutral-10']};
      padding: 6px 44px 6px 12px;
      color: ${({ theme }) => theme.colors['neutral-100']};
      font-size: 14px;
      line-height: 150%;
      text-align: left;
      width: 100%;
      background-color: transparent;

      &::placeholder {
        color: ${({ theme }) => theme.colors['neutral-100']};
      }

      &:focus-visible {
        outline-style: solid;
        outline-color: ${({ theme }) => theme.colors['secondary-60']};
        border-color: ${({ theme }) => theme.colors['secondary-60']};
        outline-offset: -1px;
      }
    }
  }

  /* .react-datepicker__tab-loop {
    display: none;
  } */

  .react-datepicker {
    border-radius: 0 0 4px 4px;
    border: 1px solid ${({ theme }) => theme.colors['neutral-30']};
  }
  .react-datepicker__header {
    background: none;
    padding: 0;
    border: none;
  }
  .react-datepicker__current-month {
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    color: ${(props) => props.theme.colors['neutral-100']};
    padding: 29px 0 29px 0;
  }
  .react-datepicker__day-name {
    font-size: 0;
    line-height: 16px;
    font-weight: 600;
    margin: 0 4px;
    color: ${(props) => props.theme.colors['neutral-50']};
    &:after {
      font-size: 12px;
    }
    &:nth-child(1):after {
      content: 'Sun';
    }
    &:nth-child(2):after {
      content: 'Mon';
    }
    &:nth-child(3):after {
      content: 'Tue';
    }
    &:nth-child(4):after {
      content: 'Wed';
    }
    &:nth-child(5):after {
      content: 'Thu';
    }
    &:nth-child(6):after {
      content: 'Fri';
    }
    &:nth-child(7):after {
      content: 'Sat';
    }
  }

  .react-datepicker__day {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: ${(props) => props.theme.colors['neutral-100']};
    height: 26px;
    line-height: 26px;
    width: 1.9rem;

    &.react-datepicker__day--disabled {
      color: ${(props) => props.theme.colors['neutral-40']};
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected:not(:hover) {
    background: none;
    color: ${(props) => props.theme.colors['primary-60']};
  }

  .react-datepicker__day--keyboard-selected:hover {
    background-color: #f0f0f0;
    color: rgb(5, 74, 217);
  }

  .react-datepicker__day--in-selecting-range {
    color: ${(props) => props.theme.colors['primary-60']};
    border-radius: 2px;
    background: ${(props) => props.theme.colors['secondary-30']};
  }

  .react-datepicker__day--selecting-range-end,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--selected {
    color: #fff;
    border-radius: 2px;
    background: ${(props) => props.theme.colors['primary-60']};
  }

  .react-datepicker__day--outside-month {
    color: ${(props) => props.theme.colors['neutral-50']};
  }

  .react-datepicker__month {
    margin: 24px;
  }

  .react-datepicker__navigation {
    margin-top: 26px;
    span:before {
      border-color: ${(props) => props.theme.colors['neutral-100']};
      border-width: 1.5px 1.5px 0 0;
      height: 7px;
      width: 7px;
    }
  }
`;
